module.exports = __webpack_public_path__ + "img/bannerRed.4cbed0f7.jpg";